<template>
  <div></div>
</template>
<script>
export default {
  data() {
    return {};
  },
  mounted() {
      this.transitiondata();
  },
  methods: {
    transitiondata() {
      this.$router.replace({
        path: "/appraise/add_enclosure",
        query: {
          fields:  this.$route.query.fields,
          monitorType: this.$route.query.monitorType,
          fielKind:this.$route.query.fielKind,
          fieldType: this.$route.query.fieldType,
          year: this.$route.query.year,
          quarter:this.$route.query.quarter,
          area: this.$route.query.area,
          id: this.$route.query.id,
          submitAuth: this.$route.query.submitAuth,
        },
      });
    },
  },
};
</script>
<style lang="less" scoped>
</style>